module.exports = __webpack_public_path__ + "img/chain15.173e6592.png";